import { useFormik } from "formik"
import React, { useState } from "react"
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap"
import * as Yup from "yup"

import CustomLabel from "components/Common/CustomLabel"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { markCandidateAssessment } from "store/actions/practicalTrainingAction"
import { showAlert } from "store/reducers/alertReducer"

const buttonStyle = (selected, text, isHovered) => {
  return {
    flex: "1 1 100px",
    margin: "4px",
    padding: "10px 15px",
    border: `1px solid  ${
      selected === text || isHovered
        ? "#00778a"
        : text == "1"
        ? "green"
        : text == "2"
        ? "red"
        : "#99c1cd"
    }`,
    background: selected === text || isHovered ? "#00778a" : "white",
    color:
      selected === text || isHovered
        ? "white"
        : text == "2"
        ? "red"
        : text == "1"
        ? "green"
        : "#5d98a0",
    fontSize: "14px",
    cursor: "pointer",
    fontWeight: selected === text ? "bold" : "normal",
    transition: "all 0.3s ease",
    borderRadius: "5px",
    minWidth: "190px",
  }
}

const ErrorMessage = ({ name, errors, touched }) => {
  if (!errors[name] || !touched[name]) return null

  return <div className="text-danger fw-semibold mt-1">{errors[name]}</div>
}

const MarkAssessmentModal = ({ isOpen, toggle, participantID }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(false)
  const [hovered, setHovered] = useState(null)

  const initialValues = {
    status: "2",
    remarks: "",
    participant_uuid: participantID || "",
  }

  const validationSchema = Yup.object().shape({
    remarks: Yup.string(),
  })

  const onSubmit = values => {
    setIsLoading(true)
    dispatch(markCandidateAssessment(values))
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          toggle()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
        setIsLoading(false)
      })
      .catch(error => {})
  }

  const { values, errors, touched, handleBlur, handleSubmit, setFieldValue } =
    useFormik({
      initialValues,
      validationSchema,
      onSubmit,
      enableReinitialize: true,
    })

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md" backdrop="static">
      <ModalHeader toggle={toggle}>{t("Evaluate the candidate")}</ModalHeader>
      <ModalBody className="pt-0">
        <Row className="">
          <Col lg={12}>
            <div className="form_field">
              <CustomLabel htmlFor="note" label={t("Remarks")} />
              <textarea
                name="remarks"
                rows="3"
                cols="30"
                maxLength={250}
                className="p-2"
                value={values.remarks}
                onBlur={handleBlur}
                onChange={e => setFieldValue("remarks", e.target.value)}
                placeholder={t("Enter remark")}
              ></textarea>
            </div>
          </Col>
          <Col lg={12}>
            <div className="g_end mt-2 gap-3">
              <button
                className="main_btn disabled-button fit_content px-4"
                type="button"
                onClick={toggle}
                disabled={isLoading}
              >
                {t("Cancel")}
              </button>
              <button
                className="main_btn fit_content px-4"
                disabled={!values.status}
                onClick={handleSubmit}
              >
                {t("Add")}
              </button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default MarkAssessmentModal
